import { useState } from 'react'
import { ModalMarco, mensajeDeError } from './ModalMarco'

interface ConfirmacionProps {
  abierto: boolean
  alCerrar: () => void
  titulo: string
  texto: string
  confirmar: string
  /** Rojo sólo para lo destructivo: Dar de baja, Quitar acceso, Desactivar. */
  peligro?: boolean
  alConfirmar: () => Promise<unknown>
}

/** Confirmación de un paso (§8.6). Cancelar nunca es rojo. */
export function Confirmacion({
  abierto,
  alCerrar,
  titulo,
  texto,
  confirmar,
  peligro = false,
  alConfirmar,
}: ConfirmacionProps) {
  const [ocupado, setOcupado] = useState(false)
  const [error, setError] = useState<string | null>(null)

  return (
    <ModalMarco
      abierto={abierto}
      alCerrar={() => {
        setError(null)
        alCerrar()
      }}
      titulo={titulo}
      guardar={confirmar}
      ocupado={ocupado}
      error={error}
      peligro={peligro}
      alEnviar={() => {
        setOcupado(true)
        setError(null)
        alConfirmar()
          .then(() => {
            alCerrar()
          })
          .catch((e: unknown) => {
            setError(mensajeDeError(e))
          })
          .finally(() => {
            setOcupado(false)
          })
      }}
    >
      <p className="text-sm">{texto}</p>
    </ModalMarco>
  )
}
